import { useState } from 'react'

import { useForm, useStore } from '@tanstack/react-form'
import { Link, getRouteApi } from '@tanstack/react-router'
import { routes } from 'commons/constants/routes'
import { Layer, LeaveConfirmation, Page, PageFace } from 'ui/components'
import { BreadCrumbs } from 'ui/temp'
import { DocTemplateEdit } from '~bank-document-templates/types'

import { TemplatesSideBar } from '../../components'
import { Footer, Form } from './components'
import { TemplateManageContext } from './context'
import { useSaveTemplate } from './hooks'

const routeApi = getRouteApi('/_app/document-templates/$id/edit')

export default () => {
  const data = routeApi.useLoaderData() as DocTemplateEdit
  const { copyFrom } = routeApi.useSearch()
  const navigate = routeApi.useNavigate()
  const [isSuccess, setIsSuccess] = useState(false)
  const { returnUrl } = routeApi.useSearch()

  const { form } = data

  const formApi = useForm({
    defaultValues: copyFrom ? { ...form, id: 0 } : form,
    onSubmit: ({ value }) => {
      openCreateConfirmation(value)
    }
  })

  const isFormDirty = useStore(formApi.store, (state) => state.isDirty && state.isValid)

  const { name, id } = form

  const { openCreateConfirmation } = useSaveTemplate({
    formApi,
    navigate,
    returnUrl,
    onSuccess: () => {
      setIsSuccess(true)
    }
  })

  return (
    <TemplateManageContext.Provider value={{ formApi, routeApi, data }}>
      <Page
        title="Template"
        subTitle={id ? name : 'Create New'}
        breadCrumbs={
          <BreadCrumbs
            links={[
              <Link to={routes.bank.documents.index}>Documents</Link>,
              <Link to={routes.bank.documentTemplates.index}>Template Manager</Link>,
              <>{id ? name : 'Create New Template'}</>
            ]}
          />
        }
        face={PageFace.SECONDARY}
        footer={<Footer />}
      >
        <TemplatesSideBar />
        <Layer rounded shadowed stretch>
          <LeaveConfirmation preventLeaving={isFormDirty && !isSuccess}>
            <Form />
          </LeaveConfirmation>
        </Layer>
      </Page>
    </TemplateManageContext.Provider>
  )
}
